import Vue from 'vue'
import * as types from './mutation-types'

export default {
  [types.SAVE_MASTERS] (state, { id, data }) {
    console.log(types.SAVE_MASTERS, data)
    Vue.set(state, id, data)
  },
  [types.UPDATE_SAVED_INPUT] (state, { index, row }) {
    console.log(types.UPDATE_SAVED_INPUT, row)
    Vue.set(state.msysinputsave, index, row)
  },
  [types.SET_USER_SETTINGS] (state, userSettings) {
    console.log(types.SET_USER_SETTINGS, userSettings)
    Vue.set(state.mstusersettings, userSettings)
  }
}
